import { render, staticRenderFns } from "./experience.vue?vue&type=template&id=2abc043e&scoped=true"
import script from "./experience.vue?vue&type=script&lang=js"
export * from "./experience.vue?vue&type=script&lang=js"
import style0 from "./experience.vue?vue&type=style&index=0&id=2abc043e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abc043e",
  null
  
)

export default component.exports